var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-grid',{attrs:{"url":"Alumini","columns":_vm.columns,"title":_vm.title,"onRowClicked":_vm.onRowClicked,"navigationPath":"onRowClicked","navigationField":"onRowClicked"}})}
var staticRenderFns = []

export { render, staticRenderFns }